"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileIcon = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Text_1 = require("../Text");
function ProfileIcon({ children, className, }) {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('flex', 'justify-center', 'items-center', 'bg-orange-200', 'rounded', 'p-1', 'w-8', 'h-8', 'cursor-pointer', className) },
        react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.BODY_S, className: "text-orange-800 cursor-pointer" }, children)));
}
exports.ProfileIcon = ProfileIcon;
//# sourceMappingURL=ProfileIcon.js.map